import { axiosInstance } from "../client";
import { AppointmentTimeSlotPlan } from "@rumble-it/common-lib/types/models/AppointmentTimeSlotPlan.interface";
import { CollectionResponse } from "@rumble-it/common-lib/types/api/CollectionResponse.interface";
import { AppointmentTimeSlotPlanFormValues } from "../../../pages/admin/appointment-time-slots/plans/components/AppointmentTimeSlotPlanForm";

export const fetchAppointmentTimeSlotPlans = async (): Promise<
  CollectionResponse<AppointmentTimeSlotPlan>
> =>
  axiosInstance
    .get(`/service-partner/appointment-time-slot-plans`)
    .then((response) => response.data);

export const createAppointmentTimeSlotPlan = async (
  data: AppointmentTimeSlotPlanFormValues,
): Promise<AppointmentTimeSlotPlan> =>
  axiosInstance
    .post(`/service-partner/appointment-time-slot-plans`, data)
    .then((response) => response.data);

export const updateAppointmentTimeSlotPlanById = async (
  id: string,
  data: AppointmentTimeSlotPlanFormValues,
): Promise<null> =>
  axiosInstance
    .put(`/service-partner/appointment-time-slot-plans/${id}`, data)
    .then((response) => response.data);

export const deleteAppointmentTimeSlotPlanById = async (
  id: string,
): Promise<null> =>
  axiosInstance
    .delete(`/service-partner/appointment-time-slot-plans/${id}`)
    .then((response) => response.data);

export const fetchAppointmentTimeSlotPlanById = async (
  id: string,
): Promise<AppointmentTimeSlotPlan> =>
  axiosInstance
    .get(`/service-partner/appointment-time-slot-plans/${id}`)
    .then((response) => response.data);
